import 'video-react/dist/video-react.css';
import { Tag } from '../../../interfaces';
import { humanizeEnum } from '../../../utils';
import { EventTagDropdownOption } from './interfaces';

export const prepareListOfDropdownOptions = (questions: Tag[]): EventTagDropdownOption[] => {
  const optionList: EventTagDropdownOption[] = [];

  questions.forEach((tag) => {
    const path = tag.id.toString();
    // not using destructuring here because TS gets all confused on type assertions

    if (tag.value_type === 'bool') {
      tag.enum_variants?.forEach(() => {
        const namePrefix = tag.name ? `${humanizeEnum(tag.name)}: ` : '';

        optionList.push({
          tag,
          name: `${namePrefix}true`,
          path,
          value: true,
        });

        optionList.push({
          tag,
          name: `${namePrefix}false`,
          path,
          value: false,
        });
      });
    }

    if (tag.value_type === 'int') {
      const displayName = tag.name
        ? `${tag.name} (${tag.min_value} - ${tag.max_value})`
        : `(${tag.min_value} - ${tag.max_value})`;

      optionList.push({
        tag,
        name: displayName,
        path,
        value: 'prompt',
      });
    }

    if (tag.value_type === 'enum') {
      // FIXME add multi selection if we ever want it
      tag.enum_variants?.forEach((value) => {
        const namePrefix = tag.name ? `${tag.name}: ` : '';

        optionList.push({
          tag,
          path,
          name: `${namePrefix}${humanizeEnum(value.variant_name)}`,
          value: value.id,
        });
      });
    }
  });

  return optionList;
};
